var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C12.0163 0 9.15483 1.18526 7.04505 3.29505C4.93526 5.40483 3.75 8.26631 3.75 11.25H0L4.8625 16.1125L4.95 16.2875L10 11.25H6.25C6.25 6.4125 10.1625 2.5 15 2.5C19.8375 2.5 23.75 6.4125 23.75 11.25C23.75 16.0875 19.8375 20 15 20C12.5875 20 10.4 19.0125 8.825 17.425L7.05 19.2C8.09177 20.2475 9.33061 21.0784 10.6951 21.6448C12.0595 22.2112 13.5226 22.5018 15 22.5C17.9837 22.5 20.8452 21.3147 22.955 19.205C25.0647 17.0952 26.25 14.2337 26.25 11.25C26.25 8.26631 25.0647 5.40483 22.955 3.29505C20.8452 1.18526 17.9837 4.44604e-08 15 0ZM13.75 6.25V12.5L19.0625 15.65L20.025 14.05L15.625 11.4375V6.25H13.75Z",
    fill: "#5E639B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.6777d244d510bb4f9711c6c3ca4b9bda.svg";
export { ForwardRef as ReactComponent };